import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import PageEmptyContent from "../utils/page.empty-content";
import {
    Card, CardBody, CardGroup
} from 'reactstrap';
import PdfIcon from 'react-icons/lib/md/picture-as-pdf'
import ExcelIcon from 'react-icons/lib/md/insert-drive-file';
import ToolTipItem from "../utils/tooltip";
import moment from "moment";
import { appHelpers } from '../../_helpers';
import './style.css'; 




const Aggregate = ({ data, downloadPdf, downloadExcel }) => (
    <div>
        <CardGroup className="sales-card mb-4">
            <Card style={{ 'flex': '1.5 0 0' }}>
                <CardBody className={'fit'}>
                    <h6 className="text-uppercase title font-weight-bold small">Download Wallet History</h6>
                    <h4 className="font-weight-normal mb-0">
                        <span className="pointer" onClick={downloadPdf}>
                            <ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="30" color="#e53335" className="icon-picture-as-pdf" />} content='Download As PDF' id={'downloadPdfIcon'} />
                        </span>&nbsp;
                        <span className="pointer" onClick={downloadExcel}>
                            <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="30" color="#00897b" className="icon-insert-drive-file" />} content='Download As Excel' id={'downloadExcelIcon'} />
                        </span>
                    </h4>
                </CardBody>
            </Card>
        </CardGroup>
    </div>
);
const DataTable = ({ data, pageIndex, downloadPdf, downloadExcel, converter }) => {

    return (data.length === 0) ?
        (<PageEmptyContent message='No record match your search!' />) :
        (
            <div className="view">
                <Aggregate data={data} downloadPdf={downloadPdf} downloadExcel={downloadExcel} />
                <div className="table-responsive">
                    <table className="table table-striped table-hover fixed">
                        <thead>
                            <tr>
                                <th style={{width:"56px"}}>
                                    <span>S/N</span>
                                </th>
                                <th>
                                    <span>Airline</span>
                                </th >
                                <th>
                                    <span>Amount</span>
                                </th>
                                <th>
                                    <span>Service Type</span>
                                </th>
                                <th >
                                    <span>Date</span>
                                </th>
                                <th>
                                    <span>Comments</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((record, i) =>
                                <tr  key={i}>
                                    <td  className="text-capitalize">{`${pageIndex + i + 1}`}</td>
                                    <td
                                        className="text-capitalize">{converter(record.AirlineName)}</td>
                                    <td>{appHelpers.numberWithCommas(record.Amount)}</td>
                                    <td>{record.IsCreditAsString}</td>
                                    <td>{moment(record.EntryDate).format('YYYY-MM-DD')}</td>
                                    <td>{record.Comment}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
};

class PaginatedResult extends React.Component {

    render() {
        const { converter, pageSize, currentPage, totalCount, navigate, records, downloadPdf, downloadExcel } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;

        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        <ServerPaginatedTable currentPage={currentPage} fetchMore={navigate}
                            target={<DataTable data={records} pageIndex={pageIndex} downloadPdf={downloadPdf} downloadExcel={downloadExcel} converter={converter}
                            />}
                            pageSize={pageSize} totalCount={totalCount}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default PaginatedResult



// WEBPACK FOOTER //
// ./src/views/airline-wallet-history/wallet-table.js